import { render, staticRenderFns } from "./ReportArhiveExpansion.vue?vue&type=template&id=2fdeb94a&scoped=true&"
import script from "./ReportArhiveExpansion.vue?vue&type=script&lang=js&"
export * from "./ReportArhiveExpansion.vue?vue&type=script&lang=js&"
import style0 from "./ReportArhiveExpansion.vue?vue&type=style&index=0&id=2fdeb94a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdeb94a",
  null
  
)

export default component.exports
import {QExpansionItem,QIcon,QCardSection,QTr,QTh,QTd,QTooltip} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QIcon,QCardSection,QTr,QTh,QTd,QTooltip}, component.options.components || {})
